import React, { FC, useEffect } from 'react';

import { SelectProps, Select } from '../Select/Select';
import { MembroUnidadeGetAllItemDTO } from 'model/reino/MembroUnidadeGetAllItemDTO';
import AvatarPessoa from '../AvatarPessoa/AvatarPessoa';
import { UnidadesResponsaveisSelector } from 'store/UnidadesResponsaveis/UnidadesResponsaveis.selector';
import { useDispatch, useSelector } from 'react-redux';
import { AlertaInline } from '../AlertaInline/AlertaInline';
import { EstadoRequisicao } from 'store/types';
import { UnidadesResponsaveisAction } from 'store/UnidadesResponsaveis/UnidadesResponsaveis.action';


interface ResponsavelTecnicoSelectProps extends SelectProps {}

export const ResponsavelTecnicoSelect: FC<ResponsavelTecnicoSelectProps> = (props) => {
  const dispatch = useDispatch();
  
  const estado = useSelector(UnidadesResponsaveisSelector.estado);
  const isCarregando = useSelector(UnidadesResponsaveisSelector.isCarregando);
  const erros = useSelector(UnidadesResponsaveisSelector.erros);
  const hasErros = useSelector(UnidadesResponsaveisSelector.hasErros);

  const responsaveis = useSelector(UnidadesResponsaveisSelector.responsaveisTecnicos);

  const opcoes = responsaveis.map(it => createOption(it));

  useEffect(() => {
    if (estado === EstadoRequisicao.OCIOSO) {
      dispatch(UnidadesResponsaveisAction.carregar());
    }
  }, [estado, dispatch]);
  
  return <Select 
    {...props}
    isLoading={isCarregando}
    isLoadingError={hasErros}
    placeholder="Responsável técnico..." 
    options={opcoes}>
    { erros && <AlertaInline mensagem={erros.data?.message} /> }
  </Select>
}


function createOption(responsavelTecnico: MembroUnidadeGetAllItemDTO) {
  return {
    label: `${responsavelTecnico.nome} - ${responsavelTecnico.unidade.sigla}`,
    value: responsavelTecnico.id,
    icone: <AvatarPessoa  pessoa={{idInstitucional: responsavelTecnico.idInstitucional, nome: responsavelTecnico.nome}} ocultarTooltip={true} exibirNome={false} comLink={false} aria-hidden={true} /> 
  }
}
